(async() => {
    const mobileNavInitStart = performance.now();
    console.log('[Navigation] Mobile navigation script loaded, initializing...');
    
    const { Core } = await importModule('Core');

    customElements.define('main-navigation-mobile', class extends Core {
        elements = {
            stage: '[data-stage]',
            navItems: '*[data-to-lvl]'
        }

        render() {
            const mobileNavInitTime = performance.now() - mobileNavInitStart;
            console.log('[Navigation] Mobile navigation initialized in:', mobileNavInitTime.toFixed(2), 'ms');
            this._handleNavigation();

          var mainNavLinks = this.closest('.mobile-drawer-menu').querySelectorAll('.mobile-main-nav-item');
          if (mainNavLinks.length) {
            mainNavLinks.forEach(function (item) {
              item.addEventListener('click',function (e) {
                var index = this.getAttribute('data-index');
                var secondaryNavs = this.closest('.mobile-drawer-menu').querySelectorAll('.mobile-second-level-menu');
                
                mainNavLinks.forEach(function (el) {
                  el.classList.remove('is-active');
                });
                
                this.classList.add('is-active');
                
                if (secondaryNavs.length) {
                  secondaryNavs.forEach(function (el) {
                    if (index == el.getAttribute('data-index')) {
                      el.classList.add('is-active');
                    } else {
                      el.classList.remove('is-active');
                    }
                  });
                }
              });
            });
          }
        }
        
        _handleNavigation() {
            this.$navItems.map(item => {
                item.addEventListener('click', e => {
                    this.$stage.dataset.current = item.dataset.toLvl;
                })
            })
        }
    });

})()